<template>
	<div class="circle-custom-m">
		<div class="circle-custom-m-wrap">
			<div class="circle-custom-m-box">
				<div class="circle-custom-m-box-wrap" id="circle-custom-m-box-wrap" @scroll="momentScroll">
					<div class="circle-custom-m-items">
						<div class="circle-custom-m-item" v-for="(moment,m_index) in momentList" :key="'circle-custom-m-'+m_index">
							<div class="circle-custom-m-avater">
								<img :src="custom.wx_photo | connectHost" alt="">
							</div>
							<div class="circle-custom-m-detail">
								<div class="circle-custom-m-name">
									<p>{{custom.wx_name}}</p>
								</div>
								<div class="circle-custom-m-text" v-html="$options.filters.formatMsg(moment.content,'text')" v-if="moment.content !== ''">
								</div>
								<div class="circle-custom-m-extra">
									<div class="circle-custom-m-pics" v-if="moment.type == 1 && moment.pics.length > 0">
										<div class="circle-custom-m-pics-wrap" v-for="(pic,index) in moment.pics">
											<img :src="pic" alt="" @click="preview(moment.pics,'image',index)">
										</div>
									</div>
									<div class="circle-custom-m-video" v-else-if="moment.type == 2">
										<img :src="moment.video.videoPic" alt="">
										<span class="circle-custom-m-v-play" @click="preview(moment.video,'video',0)"></span>
									</div>
									<div class="circle-custom-m-link" v-else-if="moment.type == 3" @click="momentJump(moment.link.url)">
										<div class="circle-custom-m-l-avater">
											<img :src="moment.link.linkImg" alt="">
										</div>
										<div class="circle-custom-m-l-text">
											<p>{{moment.link.linkText}}</p>
										</div>
									</div>
									<div class="circle-custom-m-finder" v-else-if="moment.type == 30">
										<div class="circle-custom-finder">
											<div class="circle-custom-finder-img">
												<img :src="moment.finder.thumbUrl" class="circle-custom-finder-thumb" />
												<img src="/img/video_play.png"  class="circle-custom-finder-play"/>
											</div>
											<div class="circle-custom-finder-info">
												<img :src="moment.finder.avatar"/>
												<p></p>
											</div>
											<div class="circle-custom-finder-desc">
												<p>{{moment.finder.nickname !== undefined ? moment.finder.nickname : '昵称为空'}}</p>
											</div>
											<div class="circle-custom-finder-tip">
												<img src="/img/finder.png"/>
												<p>视频号</p>
											</div>
										</div>
									</div>
									<div class="circle-custom-m-finder_live" v-else-if="moment.type == 31">
										<div class="circle-custom-finder">
											<div class="circle-custom-finder-img">
												<img :src="moment.finder_live.coverUrl" class="circle-custom-finder-thumb" />
												<img src="/img/video_play.png"  class="circle-custom-finder-play"/>
											</div>
											<div class="circle-custom-finder-info">
												<img :src="moment.finder_live.headUrl"/>
												<p>{{moment.finder_live.nickname !== undefined ? moment.finder_live.nickname : '昵称为空'}}</p>
											</div>
											<div class="circle-custom-finder-desc" v-if="moment.finder_live.desc1 !== undefined">
												<p>{{moment.finder_live.desc1}}</p>
											</div>
											<div class="circle-custom-finder-tip">
												<img src="/img/finder.png"/>
												<p>视频号直播</p>
											</div>
										</div>
									</div>
								</div>
								<div class="circle-custom-m-time">
									<p>{{moment.sendTime | rechentDate}}</p>
								</div>
								<div class="circle-custom-m-i-tools">
									<div class="circle-custom-m-i-send" @click="topMonent(moment,m_index)"><span v-if="moment.isTop === 1" class="circle-custom-red-color">取消置顶</span><span v-else>置顶</span></div>
									<div class="circle-custom-m-i-other">
										<div class="circle-custom-m-i-item">
											<p @click="replyComment(moment,m_index,1)"><span class="circle-custom-m-i-zan"></span><i>点赞</i></p>
											<p @click="showMomentInput(m_index)"><span class="circle-custom-m-i-comment"></span><i>评论</i></p>
										</div>
									</div>
								</div>
								<div class="circle-custom-m-add-comment" v-if="moment.showAddComment">
									<div class="circle-custom-m-ac-input">
										<textarea v-model="addMoment" :placeholder="argued.argued_open_id !== '' ? '回复'+argued.argued_name+'：' : ''"></textarea>
									</div>
									<div class="circle-custom-m-ac-opts">
										<span class="circle-custom-m-ac-emoji" @click="showAddMEmoji(m_index)"></span>
										<span class="circle-custom-m-ac-send" @click="replyComment(moment,m_index,2)">评论</span>
									</div>
									<div class="circle-custom-m-ac-emoji-show" v-if="moment.showEmoji">
										<emoji @emoji-call="emojiCall($event,m_index)"></emoji>
									</div>
								</div>
								<div class="circle-custom-m-fc" v-if="moment.fabulous.length > 0 || moment.comments.length > 0">
									<div class="circle-custom-m-fabulous" v-if="moment.fabulous.length > 0">
										<span class="circle-custom-m-fabulous-icon"></span>
										<span v-for="(fabulou,key) in moment.fabulous">
											<i v-text="fabulou.dzName+'、'" v-if="key+1 < moment.fabulous.length"></i>
											<i v-text="fabulou.dzName" v-if="key+1 == moment.fabulous.length"></i>
										</span>
									</div>
									<div class="circle-custom-m-fc-line" v-if="moment.fabulous.length > 0 && moment.comments.length > 0"></div>
									<div class="circle-custom-m-comment" v-if="moment.comments.length > 0">
										<div class="circle-custom-m-c-item" v-for="(comment,c_index) in moment.comments">
											<div class="circle-custom-m-c-item-wrap" v-if="comment.commentToWxid === ''">
												<span class="circle-custom-m-c-name" @click="momentFansClick(m_index,c_index,comment.commentUserWxid)">{{comment.commentUser}}：</span>
												<span class="circle-custom-m-c-text"  v-html="$options.filters.formatMsg(comment.commentText,'text')"></span>
											</div>
											<div class="circle-custom-m-c-item-wrap" v-else>
												<span class="circle-custom-m-c-name" @click="momentFansClick(m_index,c_index,comment.commentUserWxid)">{{comment.commentUser}}</span>
												<span>回复</span>
												<span class="circle-custom-m-c-name">{{comment.commentToUser}}:</span>
												<span class="circle-custom-m-c-text" v-html="$options.filters.formatMsg(comment.commentText,'text')"></span>
											</div>
											<div class="circle-custom-m-c-opts" v-if="comment.showOpt">
												<ul>
													<li @click="goChatting(comment.commentUserWxid)">聊天</li>
													<li @click="showMomentInput(m_index,comment.commentId,comment.commentUserWxid,comment.commentUser,c_index)">评论</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="circle-custom-m-loadding" v-if="!canRefresh">
						<img src="/img/loading.gif" alt="" v-if="!isEnd">
						<span v-if="!isEnd">朋友圈加载中，请稍后...</span>
						<span v-if="isEnd" class="circle-custom-m-loadding-no">暂无更多朋友圈</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Emoji from '../../components/Emoji.vue'
	import {webGetMomentList,webMomentsReplySave} from '../../network/web/moments.js'
	import {pushMomentsReply,pushMomentsTop} from '../../socket/socketEventSender.js'

	export default {
		name: 'CircleCustomMoment',
		components: {
			Emoji
		},
		props: {
			custom: {
				type: Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				canRefresh: true,
				isEnd: false,
				firstId: 0,
				momentList: [],
				addMoment: '',
				argued: {
					commentId: '0',
					argued_open_id: '',
					argued_name: ''
				},
				scrollTop: 0
			}
		},
		computed: {
			momentData() {
				return this.$store.state.otherEvent
			}
		},

		methods: {
			// 初始化基本数据
			init(){
				this.canRefresh = true
				this.isEnd = false
				this.firstId = 0
				this.momentList = []
			},
			// 初始化评论和点赞数据
			initComment(){
				this.argued =  {
					commentId: '0',
					argued_open_id: '',
					argued_name: ''
				}
				this.addMoment = ""
			},
			
			// 获取朋友圈列表数据
			getList() {
				webGetMomentList(this.custom.open_id, this.firstId, (data) => {
					let len = data.length
					if (len > 0) {
						this.drawMomentData(data)
						this.firstId = data[len - 1].id
					} else {
						this.canRefresh = false
						this.isEnd = true
					}
				})
			},
			
			// 滚动刷新数据
			momentScroll(event){
				let page = document.getElementById("circle-custom-m-box-wrap")
				this.scrollTop = page.scrollTop
				if(page.scrollTop+page.clientHeight >= page.scrollHeight-25 && this.canRefresh){
					this.canRefresh = false
					this.getList()
				}
			},
			
			// 处理朋友圈数据-根据数据，渲染不同类型的朋友圈
			drawMomentData(data){
				for (let i = 0; i < data.length; i++) {
					let type = 1
					if(data[i].type !== undefined && data[i].type !== null){
						type = parseInt(data[i].type)
					}
					switch(type){
						// 普通朋友圈-有图片
						case 1:
							this.drawBasicMomentData(data[i],1)
							break
						// 视频朋友圈
						case 3:
							this.drawBasicMomentData(data[i],2)
							break
						// 链接朋友圈
						case 4:
							this.drawBasicMomentData(data[i],3)
							break
						// 视频号朋友圈
						case 30:
							this.drawBasicMomentData(data[i],30)
							break
						// 视频号直播朋友圈
						case 31:
							this.drawBasicMomentData(data[i],31)
							break
					}
				}
				this.$nextTick(function(){
					this.canRefresh = true
				})
			},
			
			
			// 处理朋友圈数据-根据数据，渲染朋友圈-处理基本数据-单个数据
			drawBasicMomentData(data,type){
				let pics = []
				let video = {
					videoPic: '',
					videoUrl: ''
				}
				let link = {
					linkImg:'',
					linkText:'',
					url: ''
				}
				let finder = {}
				let finder_live = {}
				// 处理评论和点赞
				let comments = []
				let fabulous = []
				if(data.reply !== undefined && data.reply.length > 0){
					for (let i = 0; i < data.reply.length; i++) {
						// 点赞
						if(data.reply[i].content === ''){
							fabulous.push({
								dzName: data.reply[i].friend_name,
								dzWxid: data.reply[i].friend_open_id
							})
						}
						// 评论
						else{
							let commentToWxid = ''
							let commentToUser = ''
							if( data.reply[i].argued_open_id !== null &&  data.reply[i].argued_open_id !== "null"){
								 commentToWxid = data.reply[i].argued_open_id
							}
							if( data.reply[i].argued_name !== null &&  data.reply[i].argued_name !== "null"){
								 commentToUser = data.reply[i].argued_name
							}
							comments.push({
								commentId: data.reply[i].account_comment_id,
								commentUser: data.reply[i].friend_name,
								commentUserWxid: data.reply[i].friend_open_id,
								commentText: data.reply[i].content,
								commentToWxid: commentToWxid,
								commentToUser: commentToUser,
								showOpt: false
							})
						}	
					}
				}
				let content = data.content
				// 根据类型，处理图片，视频，链接等数据
				if(type == 1){
					if(data.img_url !== undefined && data.img_url !== ''){
						let picList = data.img_url.split(",")
						for (let i = 0; i < picList.length; i++) {
							pics.push(picList[i]+'?x-oss-process=image/auto-orient,1/resize,m_fill,w_150,h_150/quality,q_90')
						}
					}
				}else if(type == 2){
					if(data.img_url !== undefined && data.cover !== undefined){
						video = {
							videoPic: data.cover,
							videoUrl: data.img_url
						}
					}
				}else if(type == 3){
					link = {
						linkText:data.url_content,
						linkImg: data.img_url,
						url: data.url
					}
				}else if(type == 30){
					try{
						content = ''
						finder = JSON.parse(data.content)
					}catch(e){
						//TODO handle the exception
						console.log("视频号朋友圈解析异常")
					}
				}else if(type == 31){
					try{
						content = ''
						finder_live = JSON.parse(data.content)
					}catch(e){
						//TODO handle the exception
						console.log("视频号直播朋友圈解析异常")
					}
				}
				
				// 全部数据
				this.momentList.push({
					type: type,
					content:content,
					pics:pics,
					video:video,
					link: link,
					finder: finder,
					finder_live: finder_live,
					sendTime:data.time,
					fabulous:fabulous,
					comments:comments,
					snsId:data.snsId,
					showEmoji: false,
					showAddComment: false,
					isTop: data.is_top === undefined ? 0 : data.is_top
				})
			},
			
			// 图片或视频预览点击处理
			preview(content,type,index){
				if(type === 'image'){
					if(!content instanceof Array){
						return
					}
					this.$store.commit('updatePreviewFile',{
						 type:'image',
						 data:content,
						 index: parseInt(index)
					})
				}else if(type === 'video'){
					let videoData = {
						url: content.videoUrl,
						thumbUrl: content.videoPic
					}
					this.$store.commit('updatePreviewFile',{
						 type:'video',
						 data:videoData,
						 index: parseInt(index)
					})
				}
			},
			
			// 朋友圈跳转
			momentJump(url){
				window.open(url)
			},
			
			// 评论中粉丝昵称点击处理
			momentFansClick(momentIndex,commentIndex,userWxid){
				if(userWxid == this.custom.open_id){
					return
				}
				for (let i = 0; i < this.momentList[momentIndex].comments.length; i++) {
					if(i !== commentIndex){
						this.momentList[momentIndex].comments[i].showOpt = false
					}
				}
				this.momentList[momentIndex].comments[commentIndex].showOpt = !this.momentList[momentIndex].comments[commentIndex].showOpt
			},
			
			// 跳转聊天页面
			goChatting(wxid){
				let query = {
					c_id: this.custom.id,
					c_wxid: this.custom.open_id,
					f_wxid: wxid,
					type: 'fans'
				}
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			},
			
			/**
			 * 评论按钮点击-展示和隐藏评论页面
			 * @param {Object} index 朋友圈的数组索引
			 * @param {Object} commentId 评论id
			 * @param {Object} argued_open_id 准备回复的粉丝wxid
			 * @param {Object} argued_name 准备回复的粉丝昵称
			 * @param {Object} c_index 当前朋友圈的评论索引值
			 */
			showMomentInput(index,commentId,argued_open_id,argued_name,c_index){
				if(c_index !== undefined){
					this.momentList[index].comments[c_index].showOpt = false
				}
				if(commentId !== undefined && commentId != '0'){
					if(argued_open_id === this.custom.open_id){
						return
					}
					if(argued_open_id == this.argued.argued_open_id){
						this.momentList[index].showAddComment = !this.momentList[index].showAddComment
					}else{
						this.argued.argued_open_id = argued_open_id
						this.argued.argued_name = argued_name
						this.argued.commentId = commentId
						this.momentList[index].showAddComment = true
					}
				}else{
					this.argued.argued_open_id = ''
					this.argued.argued_name = ''
					this.argued.commentId = '0'
					this.momentList[index].showAddComment = !this.momentList[index].showAddComment
				}
			},
			
			// 评论页面-表情点击-表情页面的显示和隐藏
			showAddMEmoji(index){
				this.momentList[index].showEmoji = !this.momentList[index].showEmoji
			},
			
			// 表情点击回调
			emojiCall(data,index){
				console.log(data)
				this.addMoment += '['+data.title+']'
				this.momentList[index].showEmoji = false
			},
			
			// 发表评论/点赞
			replyComment(moment,index,snsType){
				if(this.addMoment === "" && snsType === 2){
					CHAT_LAYER.msg("评论内容不能为空",{icon:2})
					return
				}
				if(moment.snsId === undefined || moment.snsId === "" || moment.snsId == '0' || moment.snsId == null || moment.snsId == 'null'){
					CHAT_LAYER.msg("snsId为空",{icon:2})
					return
				}
				let content = this.addMoment
				let account_comment_id = '0'
				let argued_open_id = ''
				let argued_name = ''
				if(snsType == 1){
					content = ''
					// 判断是否点赞过
					let fabulous =  this.momentList[index].fabulous
					if(fabulous.length > 0){
						for (let i = 0; i < fabulous.length; i++) {
							if(fabulous[i].dzWxid === this.custom.open_id){
								CHAT_LAYER.msg("不能重复点赞",{icon:2})
								return
							}
						}
					}
				}else if(snsType == 2){
					argued_open_id = this.argued.argued_open_id
					argued_name = this.argued.argued_name
					account_comment_id = this.argued.commentId
				}
				let data = {
					account_open_id: this.custom.open_id,
					account_name: this.custom.wx_name,
					friend_open_id: this.custom.open_id,
					friend_name:this.custom.wx_name,
					account_sns_id: moment.snsId,
					content: content,
					account_comment_id: account_comment_id,
					argued_open_id: argued_open_id,
					argued_name: argued_name
				}
				webMomentsReplySave(data,(res)=>{
					if(res){
						if(snsType == 2){
							// 界面评论显示
							this.momentList[index].comments.push({
								commentId: 0,
								commentUser: data.account_name,
								commentUserWxid: data.account_open_id,
								commentText: data.content,
								commentToWxid: data.argued_open_id,
								commentToUser: data.argued_name
							})
							this.momentList[index].showAddComment = false
						}else if(snsType == 1){
							this.momentList[index].fabulous.push({
								dzName: data.account_name,
								dzWxid: data.account_open_id
							})
						}
						// 推送socket事件
						let phone_id = this.custom.phone_id !== undefined ? this.custom.phone_id : this.friend.phone_id
						pushMomentsReply(phone_id,snsType,data)
						this.initComment()
					}
				})
			},
			
			// 朋友圈置顶/取消置顶
			topMonent(moment,index){
				if(moment.snsId === undefined || moment.snsId === "" || moment.snsId == '0' || moment.snsId == null || moment.snsId == 'null'){
					CHAT_LAYER.msg("此条朋友圈未正常回调，不能操作",{icon:2})
					return
				}
				let phone_id = this.custom.phone_id !== undefined ? this.custom.phone_id : this.friend.phone_id
				let event = 'top';
				if(moment.isTop === 1){
					event = 'unTop'
				}
				pushMomentsTop(phone_id,moment.snsId,event)
				CHAT_LAYER.msg("推送成功，请留意页面变化！",{icon:1})
			},
			
			// 重新加载
			refresh(){
				this.init()
				this.initComment()
				this.getList()
			}
		},


		watch: {
			// 监听客服切换-当查看客服朋友圈时生效
			custom(nVal, oVal) {
				this.init()
				this.initComment()
				this.getList()
			},
			
			// 监听socket事件
			otherEvent(nVal){
				if(nVal.type === undefined){
					return
				}
				let _this = this
				if(nVal.type === 'topMoment'){
					let snsId = nVal.snsId
					let isTop = nVal.eventValue === 'top' ? 1 : 0
					let moment = null;
					for(let i = 0; i < _this.momentList.length;i++){
						if(_this.momentList[i].snsId == snsId){
							moment = _this.momentList[i];
							break;
						}
					}
					if(moment != null){
						moment.isTop = isTop
					}
				}
			}

			// 监听全局事件数据变化-只针对朋友圈和朋友圈图片
			/* momentData(nVal) {
				if (nVal.type === undefined) {
					return
				}
				switch (nVal.type) {
					// 朋友圈评论
					case "replyMoment":
						this.handleFansReplyComment(nVal)
						break;
				}
			} */
		},
		
		computed:{
			otherEvent(){
				return this.$store.state.otherEvent
			}
		},
		activated() {
			let page = document.getElementById("circle-custom-m-box-wrap")
			page.scrollTop = this.scrollTop
		}
	}
</script>

<style>
	.circle-custom-red-color{
		color: red;
	}
	.circle-custom-m {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.circle-custom-m .circle-custom-m-wrap {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.circle-custom-m-wrap .circle-custom-m-tools {
		width: 100%;
		height: 30px;
		line-height: 30px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
		box-shadow: 0 0 3px 0 #717488a6;
	}

	.circle-custom-m-wrap .circle-custom-m-tools span {
		display: block;
		width: 18px;
		height: 18px;
		margin: 0 5px;
		background-position: center;
		background-size: 20px 20px;
		background-repeat: no-repeat;
		cursor: pointer;
		border: 1px solid #CCCCCC;
		border-radius: 10px;
	}

	.circle-custom-m-t-title {
		font-weight: bold;
		color: #42B983;
	}

	.circle-custom-m-t-reload {
		background-image: url(../../assets/img/comp-reload.png);
	}

	.circle-custom-m-t-eye {
		background-image: url(../../assets/img/comp-eye.png);
		background-size: 15px 15px !important;
	}

	.circle-custom-m-wrap .circle-custom-m-box {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}

	.circle-custom-m-wrap .circle-custom-m-me-box {
		top: 0 !important;
	}

	.circle-custom-m-box .circle-custom-m-box-wrap {
		width: 100%;
		height: 100%;
		position: relative;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.circle-custom-m-box-wrap .circle-custom-m-remind {
		height: 36px;
		padding: 10px 0;
		overflow: hidden;
		border-bottom: 1px solid #ececec;
	}

	.circle-custom-m-remind .circle-custom-m-remind-box {
		margin: 0 auto;
		width: 120px;
		height: 24px;
		padding: 6px 10px;
		background-color: #374b69;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #FFFFFF;
		cursor: pointer;
	}

	.circle-custom-m-remind-box>* {
		display: block;
	}

	.circle-custom-m-remind-box img {
		width: 24px;
		height: 24px;
	}

	.circle-custom-m-remind-box .circle-custom-m-remind-num {
		padding: 0 5px;
		background-color: #ff4d00;
		margin: 0 5px 0 15px;
		height: 18px;
		line-height: 18px;
	}

	.circle-custom-m-remind-box .circle-custom-m-remind-text {
		height: 18px;
		line-height: 18px;
	}

	.circle-custom-m-box-wrap .circle-custom-m-items {
		width: 100%;
		height: auto;
		color: #666666;
	}

	.circle-custom-m-items .circle-custom-m-item {
		width: 100%;
		height: auto;
		min-height: 100px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		border-bottom: 1px solid #ececec;
		padding: 10px;
		box-sizing: border-box;
	}
	.circle-custom-m-items .circle-custom-m-item-top {
		background-color: #009688;
	}

	.circle-custom-m-items .circle-custom-m-item:last-child {
		border-bottom: none;
	}

	.circle-custom-m-item .circle-custom-m-avater {
		width: 44px;
		height: 44px;
		margin-right: 6px;
	}

	.circle-custom-m-avater img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.circle-custom-m-item .circle-custom-m-detail {
		width: 0;
		flex-grow: 1;
	}

	.circle-custom-m-detail .circle-custom-m-name {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		color: #225f8c;
	}

	.circle-custom-m-detail .circle-custom-m-text {
		padding: 5px 0;
		line-height: 20px;
	}

	.circle-custom-m-detail .circle-custom-m-extra {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.circle-custom-m-extra .circle-custom-m-pics {
		width: 100%;
		max-width: 400px;
		padding: 5px 0;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.circle-custom-m-pics .circle-custom-m-pics-wrap {
		width: 32%;
		position: relative;
		height: 0;
		padding-bottom: 32%;
		margin: 1px;
	}

	.circle-custom-m-pics-wrap img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		box-shadow: 0 0 1px 0 #5d5d5d;
	}

	.circle-custom-m-extra .circle-custom-m-video {
		width: 80%;
		max-width: 200px;
		height: auto;
		position: relative;
		padding: 5px 0;
	}

	.circle-custom-m-video img {
		width: 100%;
		height: auto;
		min-height: 80px;
		background-color: #3e3e3e;
	}

	.circle-custom-m-video .circle-custom-m-v-play {
		width: 30px;
		height: 30px;
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-image: url(../../../public/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		cursor: pointer;
	}

	.circle-custom-m-extra .circle-custom-m-link {
		width: 100%;
		height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		overflow: hidden;
		background-color: #EEEEEE;
		padding: 5px;
		box-sizing: border-box;
		cursor: pointer;
		font-size: 12px;
	}

	.circle-custom-m-link .circle-custom-m-l-avater {
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 5px;
	}

	.circle-custom-m-l-avater img {
		width: 100%;
		height: 100%;
		border-radius: 2px;
		background-color: #3e3e3e;
	}

	.circle-custom-m-link .circle-custom-m-l-text {
		width: 0;
		flex-grow: 1;
		height: 40px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.circle-custom-m-l-text p {
		display: block;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}

	.circle-custom-m-detail .circle-custom-m-time {
		height: 24px;
		line-height: 24px;
		color: #8f8f8f;
	}

	.circle-custom-m-detail .circle-custom-m-i-tools {
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
	}

	.circle-custom-m-i-tools .circle-custom-m-i-send {
		width: 60px;
		cursor: pointer;
	}

	.circle-custom-m-i-tools .circle-custom-m-i-other {
		width: 0;
		flex-grow: 1;
	}

	.circle-custom-m-i-other .circle-custom-m-i-item {
		display: flex;
		justify-content: flex-end;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
	}

	.circle-custom-m-i-item p {
		display: block;
		padding-left: 8px;
		cursor: pointer;
	}

	.circle-custom-m-i-item p span {
		width: 14px;
		height: 14px;
		display: inline-block;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 14px auto;
		vertical-align: middle;
		margin-right: 2px;
	}

	.circle-custom-m-i-item .circle-custom-m-i-reload {
		background-image: url(../../assets/img/comp-m-reload.png);
	}

	.circle-custom-m-i-item .circle-custom-m-i-zan {
		background-image: url(../../assets/img/comp-m-zan.png);
	}

	.circle-custom-m-i-item .circle-custom-m-i-comment {
		background-image: url(../../assets/img/comp-m-comment.png);
	}

	.circle-custom-m-i-item p i {
		display: inline-block;
		vertical-align: middle;
		font-style: unset;
	}

	.circle-custom-m-detail .circle-custom-m-add-comment {
		margin: 5px 0;
		position: relative;
	}

	.circle-custom-m-add-comment .circle-custom-m-ac-input {
		height: 50px;
		overflow: hidden;
	}

	.circle-custom-m-ac-input textarea {
		height: 50px;
		width: 100%;
		border: 1px solid #e3e3e3;
		padding: 5px;
		box-sizing: border-box;
		line-height: 18px;
		resize: none;
		border-radius: 4px;
		color: #888888;
	}

	.circle-custom-m-ac-input textarea:focus {
		border: 1px solid #009688;
	}

	.circle-custom-m-add-comment .circle-custom-m-ac-opts {
		width: 100%;
		margin-top: 5px;
		height: 22px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.circle-custom-m-ac-opts span {
		display: block;
		user-select: none;
		height: 22px;
		line-height: 22px;
		cursor: pointer;
	}

	.circle-custom-m-ac-opts .circle-custom-m-ac-emoji {
		width: 22px;
		background-image: url(../../assets/img/comp-c-tools-emoji.png);
		background-position: center;
		background-size: 22px auto;
	}

	.circle-custom-m-ac-opts .circle-custom-m-ac-send {
		background-color: #1178b5;
		padding: 0 5px;
		color: #FFFFFF;
	}

	.circle-custom-m-add-comment .circle-custom-m-ac-emoji-show {
		position: absolute;
		width: 405px;
		height: 200px;
		max-width: 100%;
		bottom: 32px;
		left: -5px;
	}

	.circle-custom-m-detail .circle-custom-m-fc {
		background-color: #EEEEEE;
		padding: 5px;
		position: relative;
		margin-top: 5px;
		border-radius: 2px;
	}

	.circle-custom-m-fc::after {
		display: block;
		content: '';
		width: 10px;
		height: 10px;
		background-color: #EEEEEE;
		position: absolute;
		top: -4px;
		left: 12px;
		transform: rotateZ(45deg);
	}

	.circle-custom-m-fc-line {
		margin: 5px 0;
		height: 1px;
		background-color: #ffffff;
	}

	.circle-custom-m-detail .circle-custom-m-fabulous {
		width: 100%;
		line-height: 20px;
		font-size: 12px;
	}

	.circle-custom-m-fabulous span {
		display: inline-block;
		cursor: pointer;
	}

	.circle-custom-m-fabulous .circle-custom-m-fabulous-icon {
		width: 16px;
		height: 16px;
		background-image: url(../../assets/img/comp-m-zan.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		vertical-align: text-bottom;
		margin-right: 5px;
	}

	.circle-custom-m-fabulous i {
		font-style: normal;
	}

	.circle-custom-m-detail .circle-custom-m-comment {
		width: 100%;
		font-size: 12px;
	}

	.circle-custom-m-comment .circle-custom-m-c-item {
		padding: 2px 0;
		line-height: 18px;
		position: relative;
	}

	.circle-custom-m-c-item .circle-custom-m-c-name {
		font-weight: 600;
		color: #225f8c;
		cursor: pointer;
	}

	.circle-custom-m-c-item .circle-custom-m-c-text {
		color: #999999;
	}

	.circle-custom-m-c-item .circle-custom-m-c-opts {
		position: absolute;
		width: 100px;
		height: auto;
		top: -66px;
		left: 0;
		background-color: #212121;
		z-index: 1;
		padding: 5px 5px;
		line-height: 26px;
		color: #FFFFFF;
		border-radius: 2px;
		text-indent: 5px;
	}

	.circle-custom-m-c-item .circle-custom-m-c-opts::after {
		display: block;
		content: '';
		position: absolute;
		bottom: -5px;
		left: 10px;
		width: 10px;
		height: 10px;
		background-color: #212121;
		transform: rotateZ(45deg);
	}

	.circle-custom-m-c-opts li {
		cursor: pointer;
	}

	.circle-custom-m-c-opts li:hover {
		background-color: #414141;
	}

	.circle-custom-m-c-text>img {
		height: 20px !important;
		width: auto !important;
	}

	.circle-custom-m-loadding {
		padding: 5px 0;
		text-align: center;
		color: #42B983;
	}

	.circle-custom-m-loadding>* {
		display: inline-block;
		vertical-align: middle;
	}

	.circle-custom-m-loadding img {
		margin-right: 5px;
	}

	.circle-custom-m-loadding-no {
		color: #999999 !important;
	}

	.circle-menu>.comp-chat-custom>.comp-chat-custom-all {
		display: none;
	}

	.circle-menu>.comp-chat-custom>.comp-chat-custom-list {
		top: 0;
	}
	/* 视频号消息样式 */
	.circle-custom-finder{
		width: 220px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		border: 1px solid #CCCCCC;
		border-radius: 2px;
	}
	.circle-custom-finder-img{
		width: 100%;
		height: auto;
		position: relative;
	}
	.circle-custom-finder-img > .circle-custom-finder-thumb{
		width: 100%;
		height: auto;
	}
	.circle-custom-finder-img .circle-custom-finder-play{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 40px;
		height: 40px;
	}
	.circle-custom-finder-info{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
	}
	.circle-custom-finder-info > img{
		width: 22px;
		height: 22px;
		display: block;
		margin: 0 5px;
		border-radius: 11px;
	}
	.circle-custom-finder-desc{
		padding: 0 5px;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
	}
	.circle-custom-finder-desc p{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.circle-custom-finder-tip{
		border-top: 1px solid #EEEEEE;
		margin-top: 5px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.circle-custom-finder-tip > img{
		width: 18px;
		height: 18px;
		display: block;
		margin: 0 5px;
	}
</style>
